/* eslint-disable react/forbid-dom-props */
import React from 'react';
import classnames from 'classnames';
import styles from './FormControlInfoMessage.scss';
import useLayoutDirection from './Translations/useLayoutDirection';
const FormControlInfoMessage = ({ message = '', messageAlign = 'left', additionalClassNames = '', }) => {
    const { direction, startSide, endSide } = useLayoutDirection();
    if (!message) {
        return null;
    }
    let style = startSide === 'right'
        ? { right: 0, textAlign: 'right' }
        : { left: 0, textAlign: 'left' };
    if (messageAlign === 'right_end') {
        style =
            endSide === 'right'
                ? { right: 0, textAlign: 'right' }
                : { left: 0, textAlign: 'left' };
    }
    else if (messageAlign === 'right') {
        style =
            endSide === 'right'
                ? { right: 15, textAlign: 'right' }
                : { left: 15, textAlign: 'left' };
    }
    return (<small className={classnames(styles.message, additionalClassNames)} data-layout-direction={direction} dir={direction} style={style}>
      {message}
    </small>);
};
export default FormControlInfoMessage;
